'use client'

import { ProductCardHoverGroup } from '@/feature/product/components/product-card/ProductCardHoverGroup.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import type { SelectableItemProps } from '@/ui/helpers/selectable/Selectable.client'
import { SelectableItem } from '@/ui/helpers/selectable/Selectable.client'

type ProductBundleSelectableItemProps = SelectableItemProps

// Wraps SelectableItem with ProductCardHoverGroup so the bundle's ProductCard (hasExternalHover) reacts to this shared ancestor
export function ProductBundleSelectableItem({
  className,
  ...props
}: ProductBundleSelectableItemProps) {
  return (
    <ProductCardHoverGroup className={className}>
      <SelectableItem
        onChange={(isSelected) => {
          pushToGtmDataLayer({
            event: 'gaEvent',
            eventCategory: 'plot produit',
            eventAction: 'clic coche bundle',
            eventLabel: isSelected ? 'ajout produit' : 'retrait produit',
          })
        }}
        {...props}
      >
        {props.children}
      </SelectableItem>
    </ProductCardHoverGroup>
  )
}
